export default __webpack_public_path__ + "static/media/image5.9b37aa02.jpeg";